export const HOW_IT_WAS_WORN = 'HOW_IT_WAS_WORN';
